import React from 'react';
import styled from 'styled-components';
import PageLayout from '../components/PageLayout';
import SEO from '../components/SEO';

const ContentWrapper = styled.div`
  width: 100%;
  max-width: 1600px;
  margin: 0 auto;
  padding: 80px 16px;
  text-align: center;

  @media (min-width: 768px) {
    padding: 120px 24px;
  }

  @media (min-width: 1536px) {
    padding-left: 0;
    padding-right: 0;
  }
`;

const ErrorCode = styled.h1`
  font-size: 96px;
  font-weight: 900;
  margin: 0 0 24px 0;
  color: #000;
  line-height: 1;

  @media (max-width: 768px) {
    font-size: 64px;
  }
`;

const ErrorTitle = styled.h2`
  font-size: 32px;
  font-weight: 700;
  margin: 0 0 16px 0;
  color: #1a1a1a;

  @media (max-width: 768px) {
    font-size: 24px;
  }
`;

const ErrorMessage = styled.p`
  font-size: 16px;
  color: #666;
  margin: 0;
  line-height: 1.6;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

const NotFoundPage = () => {
  return (
    <PageLayout>
      <SEO 
        title="404 - Page Not Found"
        description="The page you're looking for doesn't exist."
      />
      <ContentWrapper>
        <ErrorCode>404</ErrorCode>
        <ErrorTitle>Page Not Found</ErrorTitle>
        <ErrorMessage>Sorry, the page you're looking for doesn't exist.</ErrorMessage>
      </ContentWrapper>
    </PageLayout>
  );
};

export default NotFoundPage;
